module.exports = __webpack_public_path__ + "files/c6ad57d6323eac318d789c43208dbb60.png";